import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "home" }
const _hoisted_2 = { id: "home-summary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_profile_links = _resolveComponent("profile-links")!
  const _component_home_summary = _resolveComponent("home-summary")!
  const _component_home_info_block = _resolveComponent("home-info-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_home_summary, null, {
        name: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Boxuan Lu", -1)
        ]))]),
        vocation: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "Information Security Engineer | Full Stack Developer", -1)
        ]))]),
        location: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("p", null, "Melbourne, Australia", -1)
        ]))]),
        links: _withCtx(() => [
          _createVNode(_component_profile_links, { link: "https://github.com/BoxHezi" }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-github" })
            ]),
            text: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" boxhezi |", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_profile_links, { link: "https://www.linkedin.com/in/boxuan-lu/" }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-linkedin" })
            ]),
            text: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Boxuan Lu", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumeData, (value, key) => {
      return (_openBlock(), _createElementBlock("div", null, [
        (_openBlock(), _createBlock(_component_home_info_block, {
          title: key,
          values: value,
          key: key
        }, null, 8, ["title", "values"]))
      ]))
    }), 256))
  ]))
}